



































































































































































































































































































































































































































































































































import ActionButton from '@/components/ActionButton.vue'
import {
  getRemittances,
  cancelRemittance,
  assignRemittance,
  requestSignature,
  requestFromDraft,
  confirmRemittance,
  getTariffs,
  assignUp,
  getRemittancePDF,
  rejectRemittance,
  generateRemittanceReport,
  remittanceTotals,
  reassignRemittance,
  generateRemittanceAccountingReport,
} from '@/api/Remittances/remittances.api'
import Table from '@/components/Table.vue'
import {
  Paginator,
  Params,
  TableHeader,
  VueTable,
  VueTotal,
} from '@/utils/interfaces'
import ChipStatus from '@/components/ChipStatus.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import {
  DeliveryCurrenciesEnum,
  Remittance,
  Tariff,
} from '@/utils/interfaces/remittance.interface'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { RemittanceStatus } from '@/utils/RemittanceStatus.constants'
import RemittanceFilter from '@/components/Services/Remittances/Remittance/RemittanceFilter.vue'
import AssignDialog from '@/components/Services/Remittances/Remittance/AssignDialog.vue'
import { User } from '@/api/Auth/auth.interface'
import DetailsDialog from '@/components/Services/Remittances/Remittance/DetailsDialog.vue'
import DeliverDialog from '@/components/Services/Remittances/Remittance/DeliverDialog.vue'
import mixins from 'vue-typed-mixins'
import { reportMixin } from '@/utils/mixins/reportMixin'
import Totals from '@/components/Services/Remittances/Remittance/Totals.vue'
import { AxiosResponse } from 'axios'
import RemittanceChat from '@/components/Services/Remittances/Messages/RemittanceChat.vue'
import { getAgencies } from '@/api/Agency/agency.api'
import Autocomplete from '@/components/Autocomplete.vue'
import moment from 'moment'
import RemittancePdfInvoice from '@/components/Services/Remittances/Remittance/RemittancePdfInvoice.vue'
import EditClientOrigin from '@/components/Services/Remittances/EditClientOrigin.vue'
import EditClientDestiny from '@/components/Services/Remittances/EditClientDestiny.vue'
import { formatDate, getCardInfo } from '~/utils/functions'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'
import ProcessMlcRemittanceButton from '~/components/Services/Remittances/ProcessMlcRemittanceButton.vue'
import CopyRemittanceButton from '~/components/Services/Remittances/CopyRemittanceButton.vue'

export default mixins(reportMixin, tableHandler<Remittance>()).extend({
  components: {
    appActionButton: ActionButton,
    appChipStatus: ChipStatus,
    appTable: Table,
    appConfirmDialog: ConfirmDialog,
    appRemittanceFilter: RemittanceFilter,
    appAssignDialog: AssignDialog,
    appDetailsDialog: DetailsDialog,
    appDeliverDialog: DeliverDialog,
    appRemittanceTotals: Totals,
    appRemittanceChat: RemittanceChat,
    Autocomplete,
    RemittancePdfInvoice,
    EditClientOrigin,
    EditClientDestiny,
    FlatCard,
    TextButton,
    ProcessMlcRemittanceButton,
    CopyRemittanceButton,
  },
  data() {
    return {
      tabs: 0,
      headers: [
        {
          text: this.$t('sender'),
          value: 'client_origin_name',
          sortable: false,
        },
        {
          text: this.$t('receiver'),
          value: 'client_destiny_name',
          sortable: false,
        },
        {
          text: this.$t('created-at'),
          value: 'created_at',
        },
        {
          text: this.$t('delivery-place'),
          value: 'subregion_name',
          sortable: false,
        },
        {
          text: this.$t('currency'),
          value: 'delivery_currency',
          sortable: false,
        },
        {
          text: this.$t('delivery_amount'),
          value: 'delivery_amount',
          sortable: false,
        },
        {
          text: this.$t('delivered_at'),
          value: 'delivered_at',
          sortable: false,
        },
        {
          text: this.$t('code'),
          value: 'code',
          sortable: false,
        },
        {
          text: this.$t('status'),
          value: 'status',
          sortable: false,
        },
        {
          text: this.$t('actions'),
          value: 'actions',
          sortable: false,
        },
      ],
      status: '',
      not_from_agency: JSON.parse(
        localStorage.getItem('not_from_agency_filter') || '[]',
      ) as string | null,
      not_delivery_currency: JSON.parse(
        localStorage.getItem('not_delivery_currency_filter') || '[]',
      ) as string | null,
      items: RemittanceStatus,
      reviewItem: null as null | Remittance,
      assignItem: null as null | Remittance,
      detailsItem: null as null | Remittance,
      pdfItem: null as null | Remittance,
      dialogs: {
        confirm: false,
        assign: false,
        details: false,
        image: false,
        deliver: false,
      },
      loading: false,
      loadingReport: false,
      action: '',
      currentImage: '',
      tariffs: [] as Tariff[],
      description: '',
      allAmount: false,
      getAgencies,
      lastSelected: '',
      loadingReportAccounting: false,
      DeliveryCurrenciesEnum,
    }
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
    computedHeaders(): TableHeader[] {
      if (this.profile.role !== 'ADMIN' || this.tabs === 0) return this.headers
      else
        return [
          {
            text: this.$t('from_agency'),
            value: 'from_agency_name',
            sortable: false,
          },
          ...this.headers,
        ]
    },
    profile(): User {
      return this.$store.getters.profile
    },
    table(): VueTable {
      return (this.$refs.table as VueTable[])[this.tabs]
    },
    total(): VueTotal {
      return (this.$refs.total as VueTotal[])[this.tabs]
    },
    getter(): (
      params?: Params,
    ) => Promise<AxiosResponse<Paginator<Remittance>>> {
      const getGetter = (
        api: (
          params?: Params,
        ) => Promise<AxiosResponse<Paginator<Remittance> | any>>,
      ) => {
        const getter = (params?: Params) => {
          if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
            if (params && !params.chain_type) {
              params.chain_type = 'AGENCY'
            }
            return api({
              chain_type: 'AGENCY',
              ...params,
            })
          } else return api(params)
        }
        return (params?: Params) => {
          const newParams = {} as Params
          if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
            if (!this.yours) {
              newParams.not_from_agency = [
                this.profile.agency,
                ...(this.not_from_agency || []),
              ].join(',')
              newParams.not_delivery_currency = this.not_delivery_currency
            } else {
              newParams.from_agency__uuid = this.profile.agency
              if (params) {
                params.not_from_agency = undefined
              }
            }
          }
          return getter({ ...params, ...newParams })
        }
      }
      return getGetter(getRemittances)
    },
    totalsGetter(): (
      params?: Params,
    ) => Promise<AxiosResponse<Paginator<Remittance> | any>> {
      const getGetter = (
        api: (
          params?: Params,
        ) => Promise<AxiosResponse<Paginator<Remittance> | any>>,
      ) => {
        const getter = (params?: Params) => {
          if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
            if (params && !params.chain_type) {
              params.chain_type = 'AGENCY'
            }
            return api({
              created_at__gte: moment()
                .subtract(15, 'days')
                .toISOString(),
              chain_type: 'AGENCY',
              ...params,
            })
          } else return api(params)
        }
        return (params?: Params) => {
          const newParams = {} as Params
          if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
            if (!this.yours) {
              newParams.not_from_agency = [
                this.profile.agency,
                ...(this.not_from_agency || []),
              ].join(',')
              newParams.not_delivery_currency = this.not_delivery_currency
            } else {
              newParams.from_agency__uuid = this.profile.agency
              if (params) {
                params.not_from_agency = undefined
              }
            }
          }
          return getter({ ...params, ...newParams })
        }
      }
      return getGetter(remittanceTotals)
    },
    yours(): boolean {
      return !this.tabs
    },
    tabOptions() {
      if (this.profile.role === 'AGENT') {
        return [this.$t('remittance.remittance') + 's']
      } else return [this.$t('yours'), this.$t('from_other_agencies')]
    },
  },
  watch: {
    status(value) {
      this.newFilter({ ...this.table.lastFilter, remittance__status: value })
      const params = {} as { 'all-amount'?: boolean }
      if (this.allAmount) {
        params['all-amount'] = true
      }
      this.total.newFilter({
        ...this.table.lastFilter,
        remittance__status: value,
        not_from_agency: this.not_from_agency,
        ...params,
      })
    },
    not_from_agency: {
      handler() {
        this.newFilter({
          ...this.table.lastFilter,
          remittance__status: this.status,
          not_from_agency: this.not_from_agency,
          not_delivery_currency: this.not_delivery_currency,
        })
        const params = {} as { 'all-amount'?: boolean }
        if (this.allAmount) {
          params['all-amount'] = true
        }
        this.total.newFilter({
          ...this.table.lastFilter,
          remittance__status: this.status,
          not_from_agency: this.not_from_agency,
          ...params,
        })
      },
      deep: true,
    },
    not_delivery_currency: {
      handler() {
        this.newFilter({
          ...this.table.lastFilter,
          remittance__status: this.status,
          not_from_agency: this.not_from_agency,
          not_delivery_currency: this.not_delivery_currency,
        })
        const params = {} as { 'all-amount'?: boolean }
        if (this.allAmount) {
          params['all-amount'] = true
        }
      },
      deep: true,
    },
  },
  methods: {
    canShowCardIcon(item: Remittance) {
      if (item.delivery_currency === DeliveryCurrenciesEnum.CUP) {
        return (
          item.client_destiny_obj.credit_card &&
          !getCardInfo(item.client_destiny_obj.credit_card)
        )
      }

      return item.delivery_currency === DeliveryCurrenciesEnum.UST
    },
    itemClass(item: Remittance) {
      if (item.uuid === this.lastSelected) return 'cyan lighten-4'
      return ''
    },
    onClickRow(event: Remittance) {
      this.lastSelected = event.uuid
    },
    getGetter(
      api: (
        params?: Params,
      ) => Promise<AxiosResponse<Paginator<Remittance> | any>>,
    ) {
      const getter = (params?: Params) => {
        if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
          if (params && !params.chain_type) {
            params.chain_type = 'AGENCY'
          }
          return api({
            chain_type: 'AGENCY',
            ...params,
          })
        } else return api(params)
      }
      return (params?: Params) => {
        const newParams = {} as Params
        if (['ADMIN', 'ACCOUNTANT'].includes(this.profile.role)) {
          if (!this.yours) {
            newParams.not_from_agency = [
              this.profile.agency,
              ...(params?.not_from_agency || []),
            ].join(',')
            newParams.not_delivery_currency = this.not_delivery_currency
          } else {
            newParams.from_agency__uuid = this.profile.agency
            if (params) {
              params.not_from_agency = undefined
            }
          }
        }
        return getter({ ...params, ...newParams })
      }
    },
    onSave() {
      localStorage.setItem(
        'not_from_agency_filter',
        JSON.stringify(this.not_from_agency || []),
      )
    },
    onSaveCurrency() {
      localStorage.setItem(
        'not_delivery_currency_filter',
        JSON.stringify(this.not_delivery_currency || []),
      )
    },
    onNewFilter(params: Params) {
      this.table.newFilter(params)
      const newParams = {} as { 'all-amount'?: boolean }
      if (this.allAmount) {
        newParams['all-amount'] = true
      }
      this.total.newFilter({ ...params, ...newParams })
    },
    onRefreshTotals() {
      const newParams = {} as { 'all-amount'?: boolean }
      if (this.allAmount) {
        newParams['all-amount'] = true
      }
      this.total.newFilter({ ...this.table.lastFilter, ...newParams })
    },
    async getReport() {
      try {
        this.loadingReport = true
        await this.generateReport(this.table.lastFilter)
      } finally {
        this.loadingReport = false
      }
    },
    async getReportAccounting() {
      try {
        this.loadingReportAccounting = true
        const link = document.createElement('a')
        const response = await generateRemittanceAccountingReport(
          this.table.lastFilter,
        )
        const blob = new Blob([response.data], {
          type: response.headers['Content-Type'],
        })
        link.href = URL.createObjectURL(blob)
        link.target = '_blank'
        link.download =
          this.$t('accounting_report') +
          '-' +
          formatDate(new Date().toISOString()) +
          '.xls'
        link.click()
      } finally {
        this.loadingReportAccounting = false
      }
    },
    async downloadPDF(item: Remittance) {
      try {
        this.pdfItem = item
        const response = await getRemittancePDF(item.remittance)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = item.code + '.pdf'
        link.click()
      } finally {
        this.pdfItem = null
      }
    },
    onViewSignature(item: Remittance) {
      this.currentImage = item.signature_image
      this.dialogs.image = true
    },
    async onDetails(item: Remittance) {
      this.detailsItem = item
      this.dialogs.details = true
    },
    async onNewAssignment(data: {
      user: User
      custom_commission?: number
      description: string
    }) {
      try {
        this.loading = true
        if (this.assignItem) {
          if (
            this.assignItem.status === 'Distributing' &&
            this.assignItem.assigned_to !== this.$store.getters.profile.uuid
          ) {
            await reassignRemittance(
              this.assignItem.remittance,
              data.user.uuid,
              data.description,
              data.custom_commission,
            )
          } else if (this.assignItem.status === 'Distributing') {
            await assignRemittance(
              this.assignItem.remittance,
              data.user.uuid,
              data.description,
              data.custom_commission,
            )
          } else if (
            this.assignItem.status === 'Assigned' &&
            this.assignItem.assigned_to !== this.$store.getters.profile.uuid
          ) {
            await reassignRemittance(
              this.assignItem.remittance,
              data.user.uuid,
              data.description,
              data.custom_commission,
            )
          } else {
            await assignRemittance(
              this.assignItem.remittance,
              data.user.uuid,
              data.description,
              data.custom_commission,
            )
          }
          if (data.user.role === 'WHOLESALER') {
            this.assignItem.status = 'Distributing'
          } else {
            this.assignItem.status = 'Assigned'
          }
          this.assignItem.assigned_to = data.user.uuid
        }
      } finally {
        this.loading = false
        this.assignItem = null
      }
    },
    onAssign(item: Remittance) {
      this.assignItem = item
      this.dialogs.assign = true
    },
    onReview(item: Remittance, action: string) {
      this.assignItem = null
      this.reviewItem = item
      this.action = action
      if (this.action === 'deliver') {
        this.dialogs.deliver = true
      } else this.dialogs.confirm = true
    },
    refresh() {
      this.newFilter(this.table.lastFilter)
      const params = {} as { 'all-amount'?: boolean }
      if (this.allAmount) {
        params['all-amount'] = true
      }
      this.total.newFilter({ ...this.table.lastFilter, ...params })
    },
    removeRemittance(item: Remittance) {
      this.table.removeItem(item)
    },
    async onDone(value: boolean) {
      if (value && this.reviewItem) {
        try {
          this.loading = true
          switch (this.action) {
            case 'reject':
              await rejectRemittance(
                this.reviewItem.remittance,
                this.description,
              )
              this.reviewItem.delivery_agency = this.reviewItem.from_agency
              this.description = ''
              break

            case 'cancel':
              await cancelRemittance(this.reviewItem.remittance)
              this.reviewItem.status = 'Canceled'
              break

            case 'signature':
              await requestSignature(this.reviewItem.remittance)
              break

            case 'confirm':
              await confirmRemittance(this.reviewItem.remittance)
              this.reviewItem.status = 'Distributing'
              break

            case 'request':
              await requestFromDraft(this.reviewItem.remittance)
              this.reviewItem.status = 'Requested'
              break

            case 'distribute-up':
              await assignUp(this.reviewItem.remittance)
              this.reviewItem.delivery_agency = '123'
              break

            default:
              break
          }
        } finally {
          this.loading = false
        }
      }
      this.reviewItem = null
    },
    canDistributeUp(remittance: Remittance): boolean {
      const amount = Number(remittance.amount)
      for (let index = 0; index < this.tariffs.length; index++) {
        const element = this.tariffs[index]
        if (
          remittance.region === element.region &&
          amount >= Number(element.min_amount) &&
          amount <= Number(element.max_amount)
        )
          return true
      }
      return false
    },
    reportGetter: generateRemittanceReport,
  },
  async mounted() {
    if (this.profile.role === 'ADMIN') {
      const response = await getTariffs({
        to_agency__uuid: this.$store.getters.agency.uuid,
        limit: 100,
      })
      this.tariffs = response.data.results
    }
  },
})
